
<div class="container">
    <h3>Profile Blocked</h3>
    <p>Your Business profile is blocked. Plase contact us at <a href="mailto:support@intrxn.com">support@intrxn.com</a> for further details. </p>
    <img src="assets/images/profile-blocked.svg" alt="">
</div>
